// @flow
import type { ToastData } from '../../../types';

// How long a toast stays up, by type: the one place to tune it. Long enough to read (about 1.5 s to
// notice it plus 300 ms a word), kept between a floor and a cap per type. Material's snackbars stay
// 4–10 s; errors and warnings get longer, since they ask the user to act. 'inProgress' has no
// timeout: the flow that opened it replaces or closes it when the work ends.
export const TOAST_TIMING: { [type: string]: { min: number, max: number } } = {
  success: { min: 4000, max: 8000 },
  info: { min: 4000, max: 8000 },
  warning: { min: 7000, max: 12000 },
  error: { min: 7000, max: 12000 },
};

const NOTICE_MS = 1500;
const PER_WORD_MS = 300;

// A toast with an action (the PDF's "Visualizar") waits at least this long: the user has to get to it
export const ACTION_MIN_MS = 10000;

// After the pointer or a finger leaves a paused toast, it stays at least this long
export const RESUME_MIN_MS = 1000;

export const readingTime = (text: ?string): number => {
  const words = String(text || '').trim().split(/\s+/).filter(Boolean).length;
  return NOTICE_MS + (words * PER_WORD_MS);
};

// The toast's timeout in ms, or null when it stays until its flow closes it. `text` is what is
// shown (the translated i18nText when the toast has no text). A `timeout` in the data wins.
export const toastTimeout = (data: ?ToastData, text?: ?string): ?number => {
  if (!data) return null;
  if (typeof data.timeout === 'number' && data.timeout > 0) return data.timeout;
  if (data.type === 'inProgress') return null;

  const { min, max } = TOAST_TIMING[data.type] || TOAST_TIMING.info;
  const ms = Math.min(max, Math.max(min, readingTime(text != null ? text : data.text)));
  return data.fileURL ? Math.max(ms, ACTION_MIN_MS) : ms;
};
